import { Edit, SimpleForm, TextInput, required } from "react-admin";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { useUpdateSubmit } from "../../forms";

const ChannelEditForm = () => {
	const submit = useUpdateSubmit("channels");

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<TextInput source="name" validate={[required()]} fullWidth />
		</SimpleForm>
	);
};

export const ChannelEdit = () => (
	<Edit>
		<ChannelEditForm />
	</Edit>
);
